import { Injectable } from '@angular/core';

import { IntroJs, Step } from 'intro.js';
import { TranslateService } from '../i18n/services/translate.service';
import { WindowRef } from '../services/window-ref';

const introJs = require('intro.js');

@Injectable()
export class IntrojsService {
	public intro: IntroJs;
	public isRunning: boolean;

	protected steps: Array<Step> = [];

	public constructor(private _window: WindowRef, private _translateService: TranslateService) {
		this.intro = introJs();

		this.intro.onexit(() => {
			this.isRunning = false;
			this._window.nativeWindow.document.body.classList.remove('intro');
		});

		this._window.nativeWindow.document.addEventListener('click', (e: MouseEvent) => {
			if (e.target['classList'].length && e.target['classList'].contains('customIntrojsElement')) {
				setTimeout(() => { this.nextStep(); }, 0);
			}
			if (e.target['classList'].length &&  e.target['classList'].contains('introjs-skipbutton')) {
				this.exit();
			}
		}, false);
	}

	public addStep(step: Step) {
		this.steps.push(step);
	}

	public begin() {
		if (this.isRunning) {
			this.exit();
		}

		this.intro = null;
		this.steps = [];
		this.intro = introJs();
		this.start();

		this._window.nativeWindow.document.body.classList.add('intro');
	}

	public exit() {
		this.intro.exit();
		this.isRunning = false;
	}

	public getCurrentStep(): number {
		return this.intro['_currentStep'] + 1;
	}

	public refreshIntro(stepId: number) {
		if (this.isRunning) {
			this.exit();
			this.begin();
			this.intro.goToStep(stepId);
		}
	}

	public nextStep(id: number = -1) {
		if (this.isRunning) {
			if (this.steps[id]) {
				this.intro.goToStep(id);
			} else {
				this.intro.nextStep();
			}
		}
	}

	public prependStep(step: Step) {
		this.steps.unshift(step);
	}

	public start() {
		this.steps.push(
			{
				element: '#intro_mapsearch',
				// tslint:disable max-line-length
				intro: `<p style="font-size: 14px;">${this._translateService.translate('introjs:intro_mapsearch:description')}</p><a class="customIntrojsElement custom-intro-external-link" href="${this._translateService.translate('introjs:intro_mapsearch:video')}" target="_blank">${this._translateService.translate('introjs:intro_mapsearch')}</a>`,
				// tslint:enable max-line-length
			},
			{
				element: '#intro_searchmask',
				intro: this._translateService.translate('introjs:intro_searchmask'),
			},
			{
				element: '#intro_region',
				intro: this._translateService.translate('introjs:intro_region'),
			},
			{
				element: '#intro_hotel_multiselect',
				tooltipClass: 'customTooltip1',
				intro: this._translateService.translate('introjs:intro_hotel_multiselect'),
			},
			{
				element: '#intro_hotelview',
				intro: this._translateService.translate('introjs:intro_hotelview'),
			},
			{
				element: '#intro_hotelview_maximize',
				intro: this._translateService.translate('introjs:intro_hotelview_maximize'),
			},
			{
				element: '#intro_offers',
				intro: this._translateService.translate('introjs:intro_offers'),
			},
			{
				element: '#intro_offers',
				intro: this._translateService.translate('introjs:intro_offers:2'),
			},
			{
				element: '#intro_price_matrix_icon',
				position: 'left',
				tooltipClass: 'customTooltip3',
				intro: this._translateService.translate('introjs:intro_price_maxtrix_icon'),
			},
			{
				element: '#intro_offers',
				intro: this._translateService.translate('introjs:intro_price_maxtrix'),
			},
			{
				element: '#intro_offers',
				tooltipClass: 'customTooltip2',
				position: 'right',
				intro: this._translateService.translate('introjs:intro_offers:3'),
			},
			{
				element: '#intro_reset_search',
				intro: this._translateService.translate('introjs:intro_reset_search'),
			}
		);

		this.intro.setOptions({
			steps: this.steps,
			exitOnOverlayClick: false,
			exitOnEsc: false,
			nextLabel: this._translateService.translate('introjs:nextStep'),
			prevLabel: this._translateService.translate('introjs:prevStep'),
			doneLabel: this._translateService.translate('introjs:done'),
			skipLabel: this._translateService.translate('introjs:skip'),
		});

		this.intro.start();
		this.isRunning = true;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/introjs/introjs.service.ts